var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRogue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 227.12 141.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#b3b3b3;}.cls-1,.cls-2{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}.cls-2{stroke:#000;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.84,75.31c0,1.28-.08,2.54-.23,3.77-.35,2.84-1.1,5.55-2.19,8.09-6.61,15.42-26.88,19.1-38.89,7.39h0c-.29,.35-.59,.68-.89,1.01-7.14,7.77-18.05,10.87-28.35,8.58l-6.73-1.5c-8.56-1.9-17.28-2.95-26.05-3.12h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M102.35,63.31c1.6,3.68,2.48,7.73,2.48,12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M225.62,75.31C165.97,75.31,156.12,4.74,87.64,1.55c-11.99-.56-23.72,3.75-32.73,11.68-.46,.4-.92,.81-1.38,1.21,0,0,0,0,0,0-8.95,7.56-14.64,18.86-14.64,31.5,0,8.2,2.39,15.84,6.52,22.26,3.19-13.21,15.1-23.03,29.29-23.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M91.14,110.64c22.41,0,22.41,9.55,44.82,9.55s22.41-9.55,44.83-9.55,22.41,9.55,44.83,9.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.5,110.64c22.41,0,22.41,9.55,44.82,9.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M135.97,110.23c22.41,0,22.41-9.55,44.83-9.55s22.41,9.55,44.83,9.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M180.79,120.6c22.41,0,22.41,9.55,44.83,9.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.5,120.6c22.41,0,22.41,9.55,44.82,9.55s22.41-9.55,44.82-9.55,22.41,9.55,44.82,9.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M135.97,140.11c22.41,0,22.41-9.55,44.83-9.55s22.41,9.55,44.83,9.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.5,130.56c22.41,0,22.41,9.55,44.82,9.55s22.41-9.55,44.82-9.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M170.99,75.31c16.35,12.24,34.3,18.12,54.62,17.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.96,29.79S100.48-5.34,148.63,53.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.56,53.19s15.95,19.78,0,44.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M178.69,93.15s-14.34-5.34-24.11-17.58"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRogue);
export default __webpack_public_path__ + "static/media/Rogue.865b49b65dd46df5d691f910de6d2cd0.svg";
export { ForwardRef as ReactComponent };